/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Nativelanguage_Schwedisch2Inputs */

const en__field__enum_nativelanguage_schwedisch2 = /** @type {(inputs: _Field__Enum_Nativelanguage_Schwedisch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwedisch`)
};

const de__field__enum_nativelanguage_schwedisch2 = /** @type {(inputs: _Field__Enum_Nativelanguage_Schwedisch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwedisch`)
};

/**
* | output |
* | --- |
* | "Schwedisch" |
*
* @param {_Field__Enum_Nativelanguage_Schwedisch2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_nativelanguage_schwedisch2 = /** @type {((inputs?: _Field__Enum_Nativelanguage_Schwedisch2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Nativelanguage_Schwedisch2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_nativelanguage_schwedisch2(inputs)
	return de__field__enum_nativelanguage_schwedisch2(inputs)
});
export { _field__enum_nativelanguage_schwedisch2 as "_field__enum_nativeLanguage_Schwedisch" }